import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'
import { Dispatcher } from 'flux'

ClosureSurveyData.Dispatcher = new Dispatcher()
